module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_1.c688612f.png";